import type { PartnerAppState } from '../../../../../redux';
import type { QcStationState } from './QcStation.state';
import { generateUseSubstateSelector, generateUseStatePropSelector } from '@orthly/redux-async-actions';

export const useQcStationSelector = generateUseSubstateSelector<PartnerAppState, 'qcStation'>('qcStation');
export const useQcStationPropSelector = generateUseStatePropSelector<QcStationState>(useQcStationSelector, 'qcStation');
